export const IncidentsPermissions = {
  ViewandsearchinPropertyManagementIncidents: {
    permissionsId: '626d67c0-e28c-4c11-c9d0-08d94f66fc61',
    permissionsName: 'View and search in  Property Management Incidents',
    componentsId: null,
    components: null,
  },

  CreateIncidents: {
    components: null,
    componentsId: null,
    permissionsId: '516b127f-ae44-4021-9329-08d967db92be',
    permissionsName: 'Create Incidents'
  },

  ViewPortfolio: {
    permissionsId: '00372ad6-77be-45d7-0d7c-08d96c602a6b',
    permissionsName: 'view portfolio',
    componentsId: null,
    components: null
  },

  EditIncidents:
  {
    permissionsId: 'e3e0c9a9-f608-45c6-0d7a-08d96c602a6b',
    permissionsName: 'Edit Incidents',
    componentsId: null,
    components: null
  },
  DeleteIncidents:
  {
    permissionsId: 'e60d8586-be5a-4f7f-0d7b-08d96c602a6b',
    permissionsName: 'Delete Incidents',
    componentsId: null,
    components: null
  },
};
